<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <div class="card main-card">
            <div class="card-body">
              <!-- Search -->
              <div class="search-section">
                <div class="row mx-0">
                  <div class="col-xl-5 ps-0 mb-2 mb-xl-0">
                    <div class="row">
                      <div class="col-md-4 col-lg-5">
                        <div class="form-wrap icon-form info-container mb-3 mb-lg-0">
                          <span class="form-icon">
                            <i class="ti ti-search"></i>
                          </span>
                          <!-- <input type="text" class="form-control" placeholder="Search your organisation name"
                            v-model="searchQuery" @input="searchCompanies(1)" /> -->
                          <input type="text" class="form-control" placeholder="Search your organisation name"
                            v-model="searchQuery" @input="debouncedSearch(1)" />
                          <i class="ti ti-info-circle info-icon" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Search by Name, Organization Number and Status"></i>
                        </div>
                      </div>
                      <div class="col-md-8 col-lg-7 mb-3 mb-lg-0">
                        <user-filters :from="'organisation'" @filterData="searchCompanies"></user-filters>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-7 pe-0">
                    <div class="export-list text-sm-end">
                      <ul>
                        <li>
                          <div class="form-sorts dropdown">
                            <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                              <i class="ti ti-filter-share"></i>Filter
                            </a>
                            <div class="filter-dropdown-menu dropdown-menu dropdown-menu-xl-end">
                              <div class="filter-set-view">
                                <div class="filter-set-head">
                                  <h4><i class="ti ti-filter-share"></i>Filter</h4>
                                </div>
                                <div class="filter-content-list">
                                  <label for="search-status" class="mb-2">Organisation: Status</label>
                                  <div class="form-wrap icon-form">
                                    <span class="form-icon"><i class="ti ti-search"></i></span>
                                    <input v-model="filters.status" type="text" id="search-status" class="form-control"
                                      placeholder="Enter Value" />
                                  </div>
                                </div>
                                <!-- <div class="filter-content-list">
                                <label for="search-vat-group" class="mb-2">Organisation: Vat Group</label>
                                <div class="form-wrap icon-form">
                                  <span class="form-icon"><i class="ti ti-search"></i></span>
                                  <input v-model="filters.vatGroup" type="text" id="search-vat-group" class="form-control" placeholder="Enter Value" />
                                </div>
                              </div> -->
                                <div class="filter-content-list">
                                  <label for="search-www" class="mb-2">Organisation: www</label>
                                  <div class="form-wrap icon-form">
                                    <span class="form-icon"><i class="ti ti-search"></i></span>
                                    <input v-model="filters.www" type="text" id="search-www" class="form-control"
                                      placeholder="Enter Value" />
                                  </div>
                                </div>
                                <div class="filter-content-list">
                                  <label for="search-fax" class="mb-2">Organisation: Fax</label>
                                  <div class="form-wrap icon-form">
                                    <span class="form-icon"><i class="ti ti-search"></i></span>
                                    <input v-model="filters.fax" type="text" id="search-fax" class="form-control"
                                      placeholder="Enter Value" />
                                  </div>
                                </div>
                                <!-- <div class="filter-content-list">
                                  <label for="search-telephone" class="mb-2">Organisation: Telephone</label>
                                  <div class="form-wrap icon-form">
                                    <span class="form-icon"><i class="ti ti-search"></i></span>
                                    <input v-model="filters.telephone" type="text" id="search-telephone"
                                      class="form-control" placeholder="Enter Value" />
                                  </div>
                                </div> -->
                                <div class="filter-reset-btns">
                                  <div class="row">
                                    <div class="col-6">
                                      <a href="javascript:void(0);" class="btn btn-light"
                                        @click="resetFilters">Reset</a>
                                    </div>
                                    <div class="col-6">
                                      <a href="javascript:void(0);" class="btn btn-primary"
                                        @click="applyFilters">Filter</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li class="days-filters-row">
                          <div class="filter-set-view toggle-filter" ref="dropdown">
                            <div class="filter-set-head filter-btn">
                              <button @click.prevent="toggleAccordion" class="btn btn-light toggle-btn"><i
                                  class="ti ti-list-tree me-2"></i>Contents</button>
                              <div class="accordion filter-drop-down" id="orgAccordion" v-if="showAccordion">
                                <div class="filter-set-content">
                                  <div class="filter-set-contents accordion-collapse collapse show" id="orgCollapse"
                                    data-bs-parent="#orgAccordion">
                                    <div class="filter-content-list">
                                      <div class="form-wrap icon-form">
                                        <span class="form-icon"><i class="ti ti-search"></i></span>
                                        <input type="text" class="form-control" placeholder="Search Columns"
                                          v-model="searchTerm" />
                                      </div>
                                      <ul>
                                        <li v-for="colName in filteredColumnOptions" :key="colName.value">
                                          <div class="filter-checks">
                                            <label class="checkboxs"
                                              :class="{ 'disabled-label': selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value) }"
                                              @click.prevent="handleColumnSelection(colName.value)">
                                              <input type="checkbox" class="disabled-checkbox"
                                                :id="'checkbox-' + colName.value"
                                                :checked="selectedColumns.value.includes(colName.value)"
                                                :disabled="selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value)"
                                                @click.stop />
                                              <span class="checkmarks"></span>
                                            </label>
                                          </div>
                                          <div class="collapse-inside-text">
                                            <h5 :for="'checkbox-' + colName.value"
                                              @click="handleColumnSelection(colName.value)"
                                              :class="{ 'disabled-label': selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value) }">
                                              {{ colName.label }}
                                            </h5>
                                          </div>
                                        </li>

                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <router-link class="btn btn-primary" to="/crm/create-organisation">
                            <i class="ti ti-square-rounded-plus"></i>Add
                            Organisation
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Search -->

              <!-- Contact List -->
              <div class="table-responsive custom-table">
                <organisations-table :search-query="searchQuery" :filters="filters" ref="companiesTable"
                  :selectedColumns="selectedColumns" :columnOptions="columnOptions" />
              </div>
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="datatable-length"></div>
                </div>
                <div class="col-md-6">
                  <div class="datatable-paginate"></div>
                </div>
              </div>
              <!-- /Contact List -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';

export default {
  data() {
    return {
      title: "Organisations",
    };
  },
  setup() {
    const searchQuery = ref(""); // Example: For holding search query input
    const companiesTable = ref(null);
    const filters = ref({
      status: "",
      www: "",
      fax: "",
      // telephone: "",
    });

    // Debounce timer
    const debounceTimeout = ref(null);

    const searchCompanies = (page = 1) => {
      if (companiesTable.value) {
        companiesTable.value.fetchOrganisations(page);
      }
    };

    // Debounced search wrapper
    const debouncedSearch = (page = 1) => {
      clearTimeout(debounceTimeout.value);
      debounceTimeout.value = setTimeout(() => {
        searchCompanies(page);
      }, 1000); // triggers only after user stops typing for 500ms
    };

    const resetFilters = () => {
      Object.keys(filters.value).forEach((key) => {
        filters.value[key] = "";
      });
      applyFilters();
    };
    const applyFilters = () => {
      searchCompanies();
    };

    const showAccordion = ref(false);
    const searchTerm = ref("");
    const selectedColumns = ref([]);
    const dropdown = ref(null);

    const moduleId = ref(null);

    const columnOptions = ref([]);

    const toggleAccordion = () => {
      showAccordion.value = !showAccordion.value;
    };

    const handleColumnSelection = (value) => {
      if (selectedColumns.value.value.includes(value)) {
        selectedColumns.value.value = selectedColumns.value.value.filter(col => col !== value);
      } else {
        selectedColumns.value.value.push(value);
      }
    };

    const filteredColumnOptions = computed(() => {
      if (!searchTerm.value) return columnOptions.value.value;
      return columnOptions.value.value.filter(option =>
        option.label.toLowerCase().includes(searchTerm.value.toLowerCase())
      );
    });

    const handleClickOutside = (event) => {
      if (dropdown.value && !dropdown.value.contains(event.target)) {
        showAccordion.value = false;
      }
    };

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
      clearTimeout(debounceTimeout.value); // <-- cleanup debounce
    });

    return {
      searchQuery,
      filters,
      companiesTable,
      resetFilters,
      searchCompanies,
      debouncedSearch, // <-- expose debounced function
      applyFilters,
      showAccordion,
      searchTerm,
      selectedColumns,
      columnOptions,
      toggleAccordion,
      handleColumnSelection,
      filteredColumnOptions,
      dropdown,
      handleClickOutside,
      moduleId
    }
  }
};
</script>

<!-- <style>
.custom-table {
  height: 850px;
  overflow-x: hidden;
}

.filter-btn {
  position: relative;
}

.filter-drop-down {
  width: 350px;
  z-index: 9999;
  position: absolute;
  top: 90%;
  left: -160%;
}

.filter-set-contents .filter-content-list ul {
  max-height: 280px !important;
}

.toggle-btn {
  background-color: transparent !important;
  border: none !important;
  font-weight: 500 !important;
}

.disabled-checkbox {
  opacity: 0.6;
}

.disabled-label {
  cursor: not-allowed;
  pointer-events: none;
}
</style> -->